var EmailPreferences = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/emailpreferences',
    idAttribute: 'token',
});
